import * as React from 'react'
import { styled } from 'next-yak'

import { lightweight, standalone, SymbolProps } from '../spritesheetUtils'

const ID = 'android-app-logo-icon'

export function LogoSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 68 22">
      <g clipPath="url(#clip_android)">
        <path
          fill="#fff"
          stroke="#000"
          strokeMiterlimit="10"
          strokeWidth=".208"
          d="M63.615.104H4.281A3.545 3.545 0 0 0 .736 3.649v14.436a3.545 3.545 0 0 0 3.545 3.545h59.334a3.545 3.545 0 0 0 3.545-3.545V3.649A3.545 3.545 0 0 0 63.615.104Z"
        />
        <path fill="#0AE577" d="m5.786 6.065 6.303 3.446-1.763 1.71-5.17-5.064a.53.53 0 0 1 .63-.092Z" />
        <path
          fill="#40C3FF"
          d="M10.326 11.221 5.095 16.3A.526.526 0 0 1 5 15.994V6.531c0-.15.06-.281.155-.375l5.171 5.065Z"
        />
        <path fill="#FFC826" d="M14.444 10.797a.53.53 0 0 1 0 .932l-2.31 1.262-1.807-1.77 1.762-1.71 2.355 1.286Z" />
        <path fill="#FF3945" d="m12.134 12.99-6.348 3.47a.53.53 0 0 1-.69-.161l5.23-5.078 1.808 1.77Z" />
        <path
          fill="#000"
          stroke="#000"
          strokeMiterlimit="10"
          strokeWidth=".11"
          d="M24.129 13.15a5.52 5.52 0 0 1-1.82.325c-.898 0-1.636-.229-2.217-.783-.51-.492-.826-1.284-.826-2.207.008-1.767 1.222-3.06 3.21-3.06.685 0 1.222.15 1.477.272l-.185.625c-.317-.14-.712-.255-1.31-.255-1.442 0-2.383.897-2.383 2.383s.905 2.392 2.286 2.392c.501 0 .844-.07 1.02-.158v-1.768h-1.205V10.3h1.953v2.85ZM29.166 11.25c0 1.574-1.09 2.26-2.119 2.26-1.152 0-2.04-.844-2.04-2.19 0-1.424.932-2.26 2.11-2.26 1.179 0 2.05.889 2.05 2.19Zm-3.377.044c0 .932.537 1.636 1.293 1.636.756 0 1.293-.695 1.293-1.653 0-.721-.36-1.636-1.275-1.636-.915 0-1.31.844-1.31 1.653ZM33.995 11.25c0 1.574-1.091 2.26-2.12 2.26-1.152 0-2.04-.844-2.04-2.19 0-1.424.932-2.26 2.11-2.26 1.179 0 2.05.889 2.05 2.19Zm-3.377.044c0 .932.536 1.636 1.292 1.636.757 0 1.293-.695 1.293-1.653 0-.721-.36-1.636-1.275-1.636-.915 0-1.31.844-1.31 1.653ZM38.637 9.157c-.017.308-.035.651-.035 1.17v2.471c0 .976-.194 1.574-.607 1.943-.413.387-1.011.51-1.548.51-.536 0-1.073-.123-1.416-.351l.194-.59a2.4 2.4 0 0 0 1.249.335c.791 0 1.372-.413 1.372-1.486v-.475h-.018c-.238.396-.695.712-1.354.712-1.056 0-1.812-.897-1.812-2.075 0-1.442.941-2.26 1.917-2.26.739 0 1.143.387 1.328.738h.018l.035-.642h.677Zm-.8 1.68c0-.132-.009-.246-.044-.352-.14-.448-.519-.818-1.082-.818-.738 0-1.266.625-1.266 1.61 0 .835.422 1.53 1.257 1.53.475 0 .906-.3 1.073-.792.044-.132.062-.281.062-.413v-.765ZM39.887 7.17h.774v6.243h-.774V7.17ZM42.392 11.426c.018 1.046.686 1.477 1.46 1.477.554 0 .888-.097 1.178-.22l.132.554c-.273.123-.739.264-1.416.264-1.31 0-2.093-.862-2.093-2.146 0-1.284.757-2.295 1.997-2.295 1.389 0 1.758 1.223 1.758 2.005 0 .158-.017.282-.026.36h-2.99Zm2.269-.554c.009-.493-.202-1.258-1.073-1.258-.783 0-1.126.721-1.187 1.258h2.26ZM48.257 7.557c.37-.062.853-.115 1.468-.115.757 0 1.31.176 1.663.493.325.281.518.712.518 1.24 0 .527-.158.958-.457 1.266-.404.431-1.064.65-1.811.65a2.64 2.64 0 0 1-.616-.052v2.375h-.765V7.557Zm.765 2.858c.167.044.378.061.633.061.923 0 1.486-.448 1.486-1.266 0-.818-.554-1.16-1.398-1.16-.334 0-.59.025-.721.06v2.305ZM52.866 7.17h.774v6.243h-.774V7.17ZM57.297 13.413l-.061-.536h-.027c-.237.334-.694.633-1.301.633-.862 0-1.302-.607-1.302-1.223 0-1.028.915-1.591 2.56-1.582v-.088c0-.352-.097-.985-.968-.985a2.12 2.12 0 0 0-1.108.316l-.176-.51c.352-.228.862-.378 1.399-.378 1.301 0 1.618.888 1.618 1.741v1.592c0 .37.017.73.07 1.02h-.704Zm-.114-2.172c-.844-.018-1.803.132-1.803.959 0 .5.334.738.73.738.554 0 .906-.352 1.029-.712a.807.807 0 0 0 .044-.246v-.739ZM59.39 9.157l.932 2.515c.097.281.202.616.273.87h.017c.08-.254.168-.58.273-.887l.844-2.498h.818l-1.16 3.034c-.555 1.46-.933 2.207-1.46 2.665-.379.334-.757.466-.95.5l-.194-.65c.194-.061.449-.184.677-.378.212-.167.475-.466.651-.862a.553.553 0 0 0 .062-.184.675.675 0 0 0-.053-.203l-1.574-3.922h.844Z"
        />
      </g>
      <defs>
        <clipPath id="clip_android">
          <path fill="#fff" d="M.632 0h66.632v21.734H.632z" />
        </clipPath>
      </defs>
    </symbol>
  )
}

type LogoProps = React.SVGAttributes<SVGElement>

const LogoStandaloneContent = standalone(LogoSymbol, ID)

export const Logo = styled(function LogoStandaloneComponent(props: LogoProps) {
  return (
    <svg width="67" height="22" {...props}>
      <LogoStandaloneContent />
    </svg>
  )
})``

export const LogoLightweight = styled(function LogoComponent(props: LogoProps) {
  return <svg {...props}>{lightweight(ID)}</svg>
})``
